import { reportInfoMessage } from '../../../core/errors/reportInfoMessage';

export const actions = {
  start ({ rootGetters }) {
    const client = rootGetters['feature/client'];
    client.on('error', reportInfoMessage);
    return client.start();
  }
};
